module.exports = __webpack_public_path__ + "static/media/institution_logo.177d9acb.png";